import moment from 'moment';

function beforeOneYearVal(value){
  if(!value || value.length!=10)
    return true;

  return moment(value, "DD-MM-YYYY").add(1, 'y').isSameOrBefore(moment());
}


export const beforeOneYear = {
  messages: {
    en: (field, args) => {
      return "Data não pode ser inferior a um ano";
    },
    'pt-BR': (field, args) => {
      return "Data não pode ser inferior a um ano";
    }
  },
  validate(value, args) {
    return beforeOneYearVal(value, args);
  }
};



// WEBPACK FOOTER //
// ./src/validators/date.js